import { useState, useEffect } from 'react';
var useBreakpoint = function (_a) {
    var _b = _a.queries, queries = _b === void 0 ? {
        MOBILE: '',
        TABLET: '',
        DESKTOP: ''
    } : _b, _c = _a.resultType, resultType = _c === void 0 ? 'FULL' : _c;
    var _d = useState(null), queryMatch = _d[0], setQueryMatch = _d[1];
    useEffect(function () {
        var mediaQueryLists = {};
        var keys = Object.keys(queries);
        var isAttached = false;
        var handleQueryListener = function () {
            var updatedMatches = keys.reduce(function (acc, media) {
                acc[media] = !!(mediaQueryLists[media] && mediaQueryLists[media].matches);
                return acc;
            }, {});
            setQueryMatch(updatedMatches);
        };
        if (window && window.matchMedia) {
            var matches_1 = {};
            keys.forEach(function (media) {
                if (typeof queries[media] === 'string') {
                    mediaQueryLists[media] = window.matchMedia(queries[media]);
                    matches_1[media] = mediaQueryLists[media].matches;
                }
                else {
                    matches_1[media] = false;
                }
            });
            setQueryMatch(matches_1);
            isAttached = true;
            keys.forEach(function (media) {
                if (typeof queries[media] === 'string') {
                    mediaQueryLists[media].addListener(handleQueryListener);
                }
            });
        }
        return function () {
            if (isAttached) {
                keys.forEach(function (media) {
                    if (typeof queries[media] === 'string') {
                        mediaQueryLists[media].removeListener(handleQueryListener);
                    }
                });
            }
        };
    }, [queries]);
    if (queryMatch && resultType === 'SHORT') {
        var filteredQueryMatch = Object.keys(queryMatch).filter(function (key) { return !!queryMatch[key]; });
        return filteredQueryMatch && filteredQueryMatch.length > 0 ? filteredQueryMatch[0] : null;
    }
    return queryMatch;
};
export default useBreakpoint;
